import {
  upperFirst,
  camelCase,
  kebabCase,
} from 'lodash';
import resourceTypes from '../constants/resourceTypes';

const specialResourceName: Record<string, string | undefined> = {
  processes: resourceTypes.PROCESS,
  'risk-classes': resourceTypes.RISK_CLASS,
  'account-entities': resourceTypes.ACCOUNT_ENTITY,
  businesses: resourceTypes.BUSINESS,
  'interface-settings': 'InterfaceSettings',
  'access-management/members': resourceTypes.MEMBER,
  'access-management/permission-roles': resourceTypes.PERMISSION_ROLE,
  'access-management/api-keys': resourceTypes.API_KEY,
};

const specialResource = (name: string) => {
  const specialKebabName = Object.keys(specialResourceName)
    .find((kebabCaseName) => specialResourceName[kebabCaseName] === name);
  return specialKebabName;
};

const getResourceName = (resource: string) => `${
  upperFirst(camelCase(!specialResourceName[resource]
    ? resource.slice(0, -1) : specialResourceName[resource]))
}`;

export const getResourceFromName = (resourceName: string) => {
  const specResource = specialResource(resourceName);
  return specResource ?? kebabCase(`${resourceName}s`);
};

export default getResourceName;
